import { getterTree, mutationTree } from 'typed-vuex'
import { setState } from '~/lib/utils/store'

const GAME_MVP = 'GameMVP'
const FREEMIUM_MVP = 'FreemiumMVP'

export const state = () => ({})

export const getters = getterTree(
  state,
  {
    isGame(...args) {
      return args[1].name === GAME_MVP
    },
    isFreemiumMVP(...args) {
      return args[1].name === FREEMIUM_MVP
    },
    name(...args) {
      return args[2].auth.user?.fset?.name ?? ''
    }
  }
)

export const mutations = mutationTree(state, {
  setState
})
